import { createAction, props } from '@ngrx/store';
import { CohortTypeEnum } from 'src/portal/buyerscaddy-api/models/cohort-type-enum';
import { InsightBucketEnum } from 'src/portal/buyerscaddy-api/models/insight-bucket-enum';
import { InsightDto } from 'src/portal/buyerscaddy-api/models/insight-dto';
import { InsightIdEnum } from 'src/portal/buyerscaddy-api/models/insight-id-enum';
import { TechStackDto } from 'src/portal/buyerscaddy-api/models/tech-stack-dto';


export const loadTechStackInsights = createAction(
  '[Tech Stack] Load Insights',
  props<{ params: {cohort: CohortTypeEnum; bucket: InsightBucketEnum[]; insightIdEnum: InsightIdEnum[]; body?: TechStackDto }}>()
);

export const loadTechStackInsightsSuccess = createAction(
  '[Tech Stack] Load Insights Success',
  props<{ params: {cohort: CohortTypeEnum; bucket: InsightBucketEnum[]; insightIdEnum: InsightIdEnum[]; body?: TechStackDto }; insights: InsightDto[] }>()
);

export const loadTechStackInsightsFailure = createAction(
  '[Tech Stack] Load Insights Failure',
  props<{ error: any }>()
);

